var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.654 10.605V11.105H13.154H14.5168L14.3508 12.1084H13.154H12.654V12.6084V17.2201C12.4152 17.2469 12.1767 17.2602 11.9383 17.2602C11.7 17.2602 11.4615 17.2469 11.2227 17.2201V12.6084V12.1084H10.7227H9.38086V11.105H10.7227H11.2227V10.605V9.03079C11.2227 8.25083 11.4763 7.69409 11.8656 7.32977C12.2596 6.96104 12.8455 6.74023 13.596 6.74023C13.9428 6.74023 14.3324 6.77546 14.7169 6.8221V7.70794H14.2591C13.7454 7.70794 13.3064 7.83253 13.0083 8.15429C12.7162 8.46944 12.654 8.87369 12.654 9.20968V10.605Z",
    fill: "#0C0C22",
    stroke: "#0C0C22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.92C18.0309 22.92 22.92 18.0309 22.92 12C22.92 5.96905 18.0309 1.08 12 1.08C5.96905 1.08 1.08 5.96905 1.08 12C1.08 18.0309 5.96905 22.92 12 22.92ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#0C0C22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bf7f69b0244f378cf7d70654d446aed1.svg";
export { ForwardRef as ReactComponent };